import { Link } from './link';
import { Rect } from './rect';
import { Video } from './video';
import { Audio } from './audio';
import { TextSelection } from './text-selection';
import { ReadspeakerElement } from './readerspeaker-element';
import { PageDrawing } from './page-drawing';
import { QuickLinks } from './quick-links';

export class PageBookFeatures {

    links: Array<Link>;
    rects: Array<Rect>;
    videos: Array<Video>;
    audios: Array<Audio>;
    readspeakerElements: Array<ReadspeakerElement>;
    textSelections: Array<TextSelection>;
    pageDrawing: PageDrawing;
    quickLinks: QuickLinks;

}
